import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";
import { topics } from "@/mocks/topics";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="group flex items-center gap-2.5 cursor-pointer" aria-label="独家大瓜首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-xl font-black text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-black tracking-tight text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">{siteInfo.shortDesc}</p>
            <p className="mt-4 text-xs leading-relaxed text-background-300">
              站内涉及具体个人的内容一律化名处理，只叙述公开可见的行为与反应。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">栏目导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">热门主题</h4>
            <ul className="mt-4 space-y-2.5">
              {topics.map((t) => (
                <li key={t.slug}>
                  <Link
                    to={`/topic/${t.slug}`}
                    className="flex items-center justify-between gap-3 text-sm text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    <span>{t.name}</span>
                    <span className="text-[11px] text-background-400">{t.count} 条</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">联系与投稿</h4>
            <ul className="mt-4 space-y-3">
              {siteInfo.contactChannels.map((c) => (
                <li key={c.label} className="flex items-start gap-2.5 text-sm text-background-200">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center text-accent-300">
                    <i className={c.icon} aria-hidden="true" />
                  </span>
                  <span>
                    <span className="block text-[11px] text-background-400">{c.label}</span>
                    {c.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="flex flex-col gap-3 px-4 py-5 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© {year} {siteInfo.name} · 内容仅为公开信息整理，不构成对任何个人的定性判断</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>可信度分级：实锤 / 待证实 / 追踪中</span>
            <span className="hidden sm:inline text-background-50/25">|</span>
            <Link to="/about" className="transition-colors hover:text-accent-300 cursor-pointer">
              内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}